import React from "react";

export default function GameHTMLContainer() {
  return <div className="gameHTMLContainer"></div>;
}
